import { render } from "./CreateSiteInfo.vue?vue&type=template&id=4b5f7298"
import script from "./CreateSiteInfo.vue?vue&type=script&lang=js"
export * from "./CreateSiteInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ringpiston-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__